/**
 * Yüklemeden önce görseli küçültür.
 *
 * Modern telefonda bir kare 3–5 MB. Fatura okuma için bu çözünürlük gereksiz;
 * uzun kenarı 2000px'e indirip JPEG %82 ile kaydetmek okunabilirliği bozmadan
 * boyutu tipik olarak 10 kat düşürür. Yükleme süresi ve depolama buna bağlı.
 *
 * PDF ve küçük dosyalar OLDUĞU GİBİ geçer — PDF'i canvas'a çizmek metni
 * görsele çevirir, fatura okuma kalitesini düşürürdü.
 */
const AZAMI_KENAR = 2000;
const KALITE = 0.82;
// Bu eşiğin altındaki görseli sıkıştırmak fayda etmez, hatta büyütebilir
const KUCULTME_ESIGI = 400 * 1024;

export async function gorselKucult(dosya) {
  if (!dosya) return dosya;
  const tur = (dosya.type || '').toLowerCase();
  if (!tur.startsWith('image/')) return dosya;          // PDF vb. dokunma
  if (dosya.size <= KUCULTME_ESIGI) return dosya;

  try {
    const bitmap = await dosyayiBitmapYap(dosya);
    const enBuyuk = Math.max(bitmap.width, bitmap.height);
    const oran = enBuyuk > AZAMI_KENAR ? AZAMI_KENAR / enBuyuk : 1;
    const g = Math.round(bitmap.width * oran);
    const y = Math.round(bitmap.height * oran);

    const tuval = document.createElement('canvas');
    tuval.width = g;
    tuval.height = y;
    const ctx = tuval.getContext('2d');
    ctx.drawImage(bitmap, 0, 0, g, y);
    if (bitmap.close) bitmap.close();

    const blob = await new Promise(coz => tuval.toBlob(coz, 'image/jpeg', KALITE));
    // Küçülmediyse aslını koru
    if (!blob || blob.size >= dosya.size) return dosya;

    const ad = (dosya.name || 'gorsel').replace(/\.[^.]+$/, '') + '.jpg';
    return new File([blob], ad, { type: 'image/jpeg', lastModified: Date.now() });
  } catch {
    // Küçültme başarısızsa aslını yükle — kullanıcıyı engelleme
    return dosya;
  }
}

async function dosyayiBitmapYap(dosya) {
  if (window.createImageBitmap) {
    // HEIC gibi bazı türlerde createImageBitmap patlar; çağıran yakalıyor
    return await createImageBitmap(dosya);
  }
  return await new Promise((coz, red) => {
    const img = new Image();
    img.onload = () => coz(img);
    img.onerror = red;
    img.src = URL.createObjectURL(dosya);
  });
}

/** Okunabilir dosya boyutu: 1536 -> "1,5 KB" */
export function boyutYaz(bayt) {
  if (!bayt && bayt !== 0) return '-';
  if (bayt < 1024) return `${bayt} B`;
  if (bayt < 1024 * 1024) return `${(bayt / 1024).toFixed(1).replace('.', ',')} KB`;
  return `${(bayt / 1048576).toFixed(1).replace('.', ',')} MB`;
}
